import { NavigateFunction } from "react-router";

let globalNavigate: NavigateFunction | null = null;

export const setGlobalNavigate = (navigate: NavigateFunction) => {
  globalNavigate = navigate;
};

export const getGlobalNavigate = (): NavigateFunction => {
  if (!globalNavigate) {
    throw new Error('Global navigate is not set yet.');
  }
  return globalNavigate;
};
